import { Hospital, UsersRound, FileChartLine, UserPlus } from 'lucide-react';
import { Permission } from '@/utils/roles';

export const upperNavItems = [
  {
    title: 'Patients',
    url: '/patients',
    icon: UserPlus,
    requiredPermissions: [Permission.VIEW_PATIENTS],
    alsoActiveOn: ['/'],
  },
  {
    title: 'Reporting',
    url: '/reporting',
    icon: FileChartLine,
    requiredPermissions: [Permission.VIEW_REPORTING],
  },
];

export const lowerNavItems = [
  {
    title: 'Profiles',
    url: '/profiles',
    icon: Hospital,
    requiredPermissions: [Permission.VIEW_PROFILES],
  },
  {
    title: 'Users',
    url: '/users',
    icon: UsersRound,
    requiredPermissions: [Permission.VIEW_USERS],
  },
];

export const user = {
  firstName: 'John',
  lastName: 'Doe',
  email: 'm@example.com',
  avatar: '/avatars/shadcn.jpg',
};
